export default function () {
  return {
    plan: {
      code: null,
      name: null,
      maxUsers: 0,
      amount: null,
      amountValue: 0,
      trial: null,
      trialEffective: null,
      typeTransaction: null,
      percentDiscount: 0,
    }
  }
}
